import React, { Component } from "react";
import config from "lib/fr-config";
import ItemCategoryDropdownButtonView from "presentational/common/ItemCategoryDropdownButtonView";
import UsersItemUnitListView from "presentational/common/itemUnit/UsersItemUnitListView";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import CommonIconView from "presentational/common/CommonIconView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;

class MySelectableItemListView extends Component {
  static propTypes = {
    onItemSelect: PropTypes.func.isRequired,
    markedList: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    selectedCategory: PropTypes.string,
    onDropdownSelect: PropTypes.func.isRequired,
    onNextItemListRequest: PropTypes.func.isRequired,
    selectableItemList: PropTypes.array.isRequired,
    onItemUploadBtnClick: PropTypes.func.isRequired,
    parentCssValueForMobile: PropTypes.object,

    catListOfMine: PropTypes.array
  };

  getCssXL = () => {
    return {
      tabBtnArea: {
        marginTop:
          desktopCss.paddingBetweenTextButton -
          desktopCss.standardPaddingBetweenContent,
        marginBottom: desktopCss.standardPaddingBetweenContent,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
      },
      dropdownBtnWrapper: { marginLeft: 15 }
    };
  };
  getCssXS = () => {
    const { parentCssValueForMobile } = this.props;
    const { widthPercentOfOutfit, verticalPaddingOfOutfit } =
      parentCssValueForMobile;
    return {
      tabBtnArea: {
        marginTop:
          mobileCss.paddingBetweenTextButton -
          mobileCss.standardPaddingBetweenContent,
        marginBottom:
          mobileCss.standardPaddingBetweenContent -
          mobileCss.minusPaddingBetweenContentsForOutfitUpload,
        marginRight:
          -1 /** 탭바가 float상태일경우 소수점 연산으로 인해 오른쪽 1px이 작아져 아이템 썸네일이 새어나오는 문제위해 강제조정 */,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        position: "sticky",
        /** top: 소수점 계산으로 아웃핏 이미지와 해당 탭버튼 실틈 보일때 있어서 1px 줄임 */
        top: `calc(((100vw * (${widthPercentOfOutfit} / 100)) / ${
          config.outfitImage.RATIO
        }) + ${verticalPaddingOfOutfit * 2}px - 1px)`,
        backgroundColor: colorCss.colorOfBackground,
        zIndex: 1250 /** 아웃핏 클릭후 나타나는 모달보다 약간 작고, 아웃핏 이미지보다는 약간 큰값으로 설정함 */,
        padding: "10px 0"
      },
      dropdownBtnWrapper: { marginLeft: 15, marginTop: 8, marginBottom: 8 }
    };
  };

  handleSelect = (key, category) => {
    const { onDropdownSelect } = this.props;

    window.scrollTo(0, 0);
    onDropdownSelect(key, category);
  };

  render() {
    const {
      onItemSelect,
      markedList,
      catListOfMine,
      isLoading,
      isEnd,
      selectedCategory,
      onNextItemListRequest,
      selectableItemList,
      onItemUploadBtnClick
    } = this.props;
    const css =
      getDeviceType() === "mobile" ? this.getCssXS() : this.getCssXL();

    return (
      <div>
        <div style={css.tabBtnArea}>
          <ContainedCommonButtonView
            onClick={onItemUploadBtnClick}
            design="bold"
          >
            <CommonIconView type={"add"} />
            <TXT name="btnCommonContained_uploadItemForOutfitUpload" />
          </ContainedCommonButtonView>
          {catListOfMine && selectedCategory && (
            <div style={css.dropdownBtnWrapper}>
              <ItemCategoryDropdownButtonView
                disableRightMargin
                dropdownName={"category"}
                categoryList={catListOfMine}
                selectedItem={selectedCategory}
                onSelect={this.handleSelect}
              />
            </div>
          )}
        </div>
        <UsersItemUnitListView
          itemList={selectableItemList}
          isItemListLoading={isLoading}
          isItemListEnd={isEnd}
          onItemClick={onItemSelect}
          onNextItemListRequest={onNextItemListRequest}
          markedList={markedList}
          emptyListText={<TXT name="msg_emptyListMyItem" />}
        />
      </div>
    );
  }
}

export default MySelectableItemListView;
